export default "__VITE_ASSET__CKvVpTMg__"